module.exports = __webpack_public_path__ + "assets/images/ranger-logo.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/ranger-logo.jpg
// module id = 1523
// module chunks = 1